import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * Wraps the app for light/dark theme support.
 * Default: light. Toggle later with useTheme() from "next-themes".
 * Adds .dark to <html> when dark mode is active so shadcn and Tailwind dark: work.
 */
export function ThemeProvider({ children, ...props }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      storageKey="business-profile-theme"
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
